import React from 'react'
import AllOrders from '../../components/table/Utable'
import Navbar from '../../components/navbar/Navbar'
import Sidebar from '../../components/sidebar/Sidebar'
import OrderChart from '../../components/chart/AreaChart/ordersAreaChart'
export default function orders() {
  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="homeContainer">
          <Navbar />
          <div className="charts">
            <OrderChart title="Last 6 Months (Revenue)" aspect={2 / 1} />
          </div>
          <div className="listContainer">
            <div className="listTitle">Latest Transactions</div>
            <AllOrders />
          </div>
        </div>
      </div>


                
      </>
  )
}
